import {register} from '@shopify/theme-sections';

import renderProductCard from '../components/product-card-template';
import {initWishlistCallback} from '../utils/wishlist';

const selectors = {
  widget: '[data-widget="search"]',
};

const classes = {
  bodySortActive: 'sort-is-active',
};

export default register('search-main', {
  onLoad() {
    const container = this.container;
    const sectionSettings = this.container.dataset.sectionSettings || '{}';
    const settings = JSON.parse(sectionSettings);

    const widgetElem = container.querySelector(selectors.widget);

    if (!widgetElem) return;

    initWishlistCallback(selectors.widget);

    const itemsPerPage = settings?.itemsPerPage || 16;
    const noResultsWidgetId = settings?.noResultsWidgetId;

    window.Tagalys?.UIWidgets.SearchResults.init(selectors.widget, {
      templates: {
        widget: {
          initialState: {
            layoutView: 'default',
            showSortModal: false,
          },
          labels: {
            searchResults: {
              heading: {
                standard: window.theme?.strings.search?.titleWithCount,
                corrected: window.theme?.strings.search?.titleCorrected,
                partialMatches: window.theme?.strings.search?.titlePartialMatches,
              },
              noResultsHeading: window.theme?.strings?.search?.noResults || 'Sorry, no products found.',
            },
            filters: {
              drawerFilterToggle: window.theme?.strings?.collection?.filtersTitle || 'Filter',
              clearAllFilters: window.theme?.strings?.collection?.filtersClearAll || 'Clear All',
              singleResult: window.theme?.strings?.collection?.filtersResultsOne || 'Result',
              multipleResults: window.theme?.strings?.collection?.filtersResultsOther || 'Results',
              applyFilters: window.theme?.strings?.collection?.filtersApply || 'Apply',
              noMatch: window.theme?.strings?.collection?.filtersNoMatch || 'No products found',
            },
            sortOptions: {
              sortBy: window.theme?.strings?.collection?.sortLabel || 'Sort',
            },
            layoutSwitcher: {
              view: window.theme?.strings?.collection?.layoutView || 'View',
              defaultDesktop: window.theme?.strings?.collection?.layoutDefaultDesktop || '4',
              altDesktop: window.theme?.strings?.collection?.layoutAltDesktop || '3',
              defaultMobile: window.theme?.strings?.collection?.layoutDefaultMobile || '2',
              altMobile: window.theme?.strings?.collection?.layoutAltMobile || '1',
            },
            pagination: {
              loadMore: window.theme?.strings?.collection?.loadMore || 'Load more',
              loading: window.theme?.strings?.collection?.loading || 'Loading...',
            },
          },
          options: {
            limit: itemsPerPage,
            includeTagalysCSS: false,
          },
          render: function (html, args) {
            const props = args.props;
            const helpers = props.helpers;
            const labels = args.labels;

            if (helpers.isInitialLoading()) {
              return html` <${args.templates.loader} /> `;
            }

            if (helpers.hasNoSearchResults() && !helpers.hasAnyFiltersApplied()) {
              return html` <${args.templates.noResults} /> `;
            }

            return html`
              <div class="container">
                <${args.templates.header} />
                <div class="results-navbar ${window.theme?.collection?.enableStickyToolbar ? 'sticky' : ''}">
                  <${args.templates.productListHeader} />
                </div>
                <${args.templates.filters} />
                <${args.templates.products} />
                <${args.templates.pagination} />
                ${helpers.hasNoSearchResults() && helpers.hasAnyFiltersApplied()
                  ? html`<div class="results-navbar__no-match">
                      <p class="text--regular">${labels.filters.noMatch}</p>
                    </div>`
                  : ''}
              </div>
            `;
          },
        },
        noResults: {
          options: {
            widgets: [
              {
                widgetId: noResultsWidgetId,
                options: {
                  templates: {
                    widget: {
                      options: {
                        limit: settings?.noResultsWidgetLimit || 8,
                        displayFormat: 'carousel',
                        includeTagalysCSS: false,
                        carouselOptions: {
                          perPage: {
                            300: 2,
                            768: 3,
                            1280: 4,
                          },
                        },
                      },

                      render: function (html, args) {
                        const props = args.props;
                        const helpers = props.helpers;
                        const products = helpers.getProducts();

                        if (props.loading === false) {
                          if (products.length === 0) {
                            return null;
                          }
                          return html`
                            <div class="container">
                              <${args.templates.productList} />
                            </div>
                          `;
                        }
                      },
                    },
                    products: {
                      render: function (html, args) {
                        const props = args.props;
                        const products = props.helpers.getProducts();

                        return html`
                          <div class="products products-carousel">
                            ${products.map((product, index) => {
                              return html` <${args.templates.product} key=${index} product=${product} /> `;
                            })}
                          </div>
                        `;
                      },
                    },
                    product: {
                      render: function (html, args) {
                        const props = args.props;
                        const product = props.product;
                        const helpers = props.helpers;

                        return html`<div dangerouslySetInnerHTML=${{__html: renderProductCard(product, helpers)}} />`;
                      },
                    },
                    carouselActions: {
                      render: function (html, args) {
                        const props = args.props;

                        return html`
                          <button
                            class="products-carousel__btn products-carousel__prev"
                            disabled=${props.helpers.carousel.isFirstSlide()}
                            onClick=${props.helpers.carousel.goLeft}
                          >
                            <svg
                              aria-label="Chevron left icon"
                              class="icon icon-chevron-left"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="m14 18-6-6 6-6"
                                stroke="currentColor"
                                stroke-width="1.5"
                                stroke-linecap="square"
                              />
                            </svg>
                          </button>

                          <button
                            class="products-carousel__btn products-carousel__next"
                            disabled=${props.helpers.carousel.isLastSlide()}
                            onClick=${props.helpers.carousel.goRight}
                          >
                            <svg
                              aria-label="Chevron right icon"
                              class="icon icon-chevron-right"
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="m10 18 6-6-6-6"
                                stroke="currentColor"
                                stroke-width="1.5"
                                stroke-linecap="square"
                              />
                            </svg>
                          </button>
                        `;
                      },
                    },
                  },
                },
              },
            ],
          },
          render: function (html, args) {
            const labels = args.labels;

            return html`
              <div class="search-main__content search-main__no-results">
                <div class="container">
                  <div class="search-main__header">
                    <h1>${labels.searchResults.noResultsHeading}</h1>
                  </div>
                  <div class="product-recommendations">
                    <${args.templates.noResultsWidgets} />
                  </div>
                </div>
              </div>
            `;
          },
        },
        header: {
          render: function (html, args) {
            return html` <div class="search-main__header"><${args.templates.heading} /></div> `;
          },
        },
        productListHeader: {
          render: function (html, args) {
            return html` <${args.templates.infoAndActions} /> `;
          },
        },
        infoAndActions: {
          render: function (html, args) {
            const props = args.props;
            const helpers = props.helpers;
            const labels = args.labels;

            return html`
              <div class="results-navbar__row">
                <div class="results-navbar__row__item">
                  <button
                    onClick=${helpers.openFilterDrawer}
                    class="results-navbar__filter-toggle results-navbar__toggle-btn btn--text btn-none"
                  >
                    ${labels.filters.drawerFilterToggle}
                    <svg
                      aria-label="Chevron down icon"
                      class="icon icon-chevron-down"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="m18 9-6 6-6-6"
                        stroke="currentColor"
                        stroke-width="1.5"
                        stroke-linecap="square"
                        vector-effect="non-scaling-stroke"
                      />
                    </svg>
                  </button>
                </div>
                <div class="results-navbar__row__item">
                  <${args.templates.layoutSwitcher} />
                  <${args.templates.sortOptions} />
                </div>
              </div>
            `;
          },
        },
        filters: {
          options: {
            showFiltersInDrawer: () => true,
          },
          render: function (html, args) {
            const props = args.props;
            const helpers = props.helpers;
            const labels = args.labels;
            const filters = helpers.getFilters();
            const totalProductsCount = helpers.getTotalProductsCount();
            const resultsLabel =
              totalProductsCount === 1 ? labels.filters.singleResult : labels.filters.multipleResults;

            const isDrawerOpen = helpers.isFilterDrawerOpen();

            return html`
              <div class="filters-drawer${isDrawerOpen ? ' filters-drawer--active' : ''}" aria-hidden=${!isDrawerOpen}>
                <${args.templates.filtersHeader} />

                <div class="filters-drawer__body">
                  ${props.showAppliedFilters ? html` <${args.templates.appliedFilters} /> ` : null}

                  <div class="accordion" id="filters-accordion">
                    ${filters.map(
                      (filter, index) => html`<${args.templates.filter} filter=${filter} index=${index} />`
                    )}
                  </div>
                </div>

                <div class="filters-drawer__footer">
                  <p class="text--regular">${totalProductsCount} ${resultsLabel}</p>
                  <button class="btn--accent" type="button" onClick=${helpers.closeFilterDrawer}>
                    ${labels.filters.applyFilters}
                  </button>
                </div>
              </div>

              <div class="modal-overlay modal-overlay--filters" onClick=${helpers.closeFilterDrawer} />
            `;
          },
        },
        filtersHeader: {
          render: function (html, args) {
            const props = args.props;
            const labels = args.labels;

            return html`
              <div class="filters-drawer__header">
                <h4 class="filters-drawer__heading text--small">${labels.filters.drawerFilterToggle}</h4>
                <button
                  type="button"
                  class="filters-drawer__close btn--text btn-none"
                  onClick=${props.helpers.closeFilterDrawer}
                  aria-label="Close filters"
                >
                  <${args.templates.closeIcon} />
                </button>
              </div>
            `;
          },
        },
        filter: {
          render: function (html, args) {
            const props = args.props;
            const helpers = props.helpers;

            let filterId = props.filter.id.replaceAll('_', '-').replaceAll('.', '-');

            if (filterId.startsWith('-')) {
              filterId = filterId.substring(1);
            }

            const isExpanded = props.collapsible ? helpers.isCollapsibleFilterExpanded(props.filter.id) : false;

            return html`
              <div class="filter ${isExpanded ? 'expanded' : 'collapsed'}">
                <${args.templates.filterHeader}
                  filterHeading=${props.filter.name}
                  filterId=${props.filter.id}
                  filterIdHandle=${filterId}
                />
                <${args.templates.filterItems} filter=${props.filter} filterIdHandle=${filterId} />
              </div>
            `;
          },
        },
        filterHeader: {
          render: function (html, args) {
            const props = args.props;
            const helpers = props.helpers;

            return html`
              <button
                class="filter__toggle btn--text btn-none"
                data-toggle="collapse"
                data-target="#filter-${props.filterIdHandle}-collapse"
                aria-expanded="false"
                aria-controls="filter-${props.filterIdHandle}-collapse"
                onClick=${() => {
                  helpers.toggleCollapsibleFilter(props.filterId);
                }}
              >
                ${props.filterHeading}
                <svg
                  aria-label="Plus icon"
                  class="icon icon-plus"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 5v14m-7-7h14"
                    stroke="currentColor"
                    stroke-width="1.5"
                    vector-effect="non-scaling-stroke"
                  />
                </svg>
              </button>
            `;
          },
        },
        appliedFilters: {
          render: function (html, args) {
            const props = args.props;
            const helpers = props.helpers;
            const labels = args.labels;
            const appliedFilters = helpers.getAppliedFilters(true);
            if (!appliedFilters.length) return;

            return html`
              <div class="filters-drawer__topbar">
                <ul class="applied-filters">
                  ${appliedFilters.map((appliedFilter) => {
                    if (appliedFilter.type === 'range') {
                      return html`
                        <li onClick=${() => helpers.clearFilter(appliedFilter.id)} class="applied-filter">
                          ${helpers.labelFormatter(
                            appliedFilter.display_format,
                            appliedFilter.selected_min,
                            appliedFilter.currency
                          )}
                          -
                          ${helpers.labelFormatter(
                            appliedFilter.display_format,
                            appliedFilter.selected_max,
                            appliedFilter.currency
                          )}

                          <${args.templates.closeIcon} />
                        </li>
                      `;
                    }
                    return appliedFilter.items.map((filterItem) => {
                      return html`
                        <li
                          class="applied-filter"
                          onClick=${() => helpers.clearFilter(appliedFilter.id, filterItem.id)}
                        >
                          ${filterItem.name}

                          <${args.templates.closeIcon} />
                        </li>
                      `;
                    });
                  })}
                  <li>
                    <button
                      type="button"
                      class="filters__clear text--regular btn-none"
                      onclick=${helpers.clearAllFilters}
                    >
                      ${labels.filters.clearAllFilters}
                    </button>
                  </li>
                </ul>
              </div>
            `;
          },
        },
        filterItems: {
          render: function (html, args) {
            const props = args.props;

            if (props.filter.type === 'checkbox') {
              return html`
                <div
                  class="collapse filter__body filter__body--checkboxes"
                  id="filter-${props.filterIdHandle}-collapse"
                  data-parent="#filters-accordion"
                >
                  <${args.templates.filterCheckBoxes}
                    filterId=${props.filter.id}
                    filterIdHandle=${props.filterIdHandle}
                    filterItems=${props.filter.items}
                  />
                </div>
              `;
            }
            return html`
              <div
                class="collapse filter__body filter__body--range"
                id="filter-${props.filterIdHandle}-collapse"
                data-parent="#filters-accordion"
              >
                <${args.templates.rangeSliderFilterItem} filter=${props.filter} />
              </div>
            `;
          },
        },
        filterCheckBoxes: {
          render: function (html, args) {
            const props = args.props;

            return html`
              <ul class="filter__list text--regular">
                ${props.filterItems.map((filterItem, index) => {
                  return html`
                <${args.templates.checkboxFilterItem}
                  filterId=${props.filterId}
                  filterIdHandle=${props.filterIdHandle}
                  filterItem=${filterItem}
                  index=${index + 1}
                >
                ${
                  filterItem.selected && filterItem.items
                    ? html`
                        <${args.templates.filterCheckBoxes}
                          filterId=${props.filterId}
                          filterItems=${filterItem.items}
                        />
                      `
                    : null
                }
              </${args.templates.checkboxFilterItem}>
            `;
                })}
              </ul>
            `;
          },
        },
        checkboxFilterItem: {
          render: function (html, args) {
            const props = args.props;
            const helpers = props.helpers;

            const onFilterClick = (event) => {
              event.stopPropagation();
              if (props.filterItem.selected) {
                helpers.clearFilter(props.filterId, props.filterItem.id);
              } else {
                helpers.applyFilter(props.filterId, props.filterItem.id);
              }
            };

            return html`
              <li class="filter__list-item" data-filter-item-id=${props.filterItem.id} onClick=${onFilterClick}>
                <input
                  type="checkbox"
                  name=${props.filterIdHandle}
                  value="${props.filterItem.name}"
                  class="filter__checkbox"
                  id=${`Filter-${props.filterIdHandle}-${props.index}`}
                  checked=${props.filterItem.selected}
                />
                <label class="filter__label" for=${`Filter-${props.filterIdHandle}-${props.index}`}
                  >${props.filterItem.name}</label
                >
              </li>
            `;
          },
        },
        rangeSliderFilterItem: {
          render(html, args) {
            const props = args.props;
            const labels = args.labels;
            const helpers = props.helpers;

            return html`
              <div class="range-slider filter-item">
                <div ref=${props.sliderRef} />
                <div class="range-slider__inputs">
                  <div class="range-slider__input">
                    <label for="Filter-filter.v.price.gte">${window.theme.strings.collection.filtersPriceFrom}</label>
                    <input
                      id="Filter-filter.v.price.gte"
                      type="number"
                      placeholder=${props.filter.min}
                      min=${props.filter.min}
                      max=${props.filter.max}
                      value=${props.sliderInputValues[0]}
                      onblur=${props.onInputBlur}
                      onchange=${props.onMinChange}
                    />
                  </div>
                  <div class="range-slider__input">
                    <label for="Filter-filter.v.price.lte">${window.theme.strings.collection.filtersPriceTo}</label>
                    <input
                      id="Filter-filter.v.price.lte"
                      type="number"
                      placeholder=${props.filter.max}
                      min=${props.filter.min}
                      max=${props.filter.max}
                      value=${props.sliderInputValues[1]}
                      onblur=${props.onInputBlur}
                      onchange=${props.onMaxChange}
                    />
                  </div>
                </div>
              </div>
            `;
          },
        },
        layoutSwitcher: {
          render: function (html, args) {
            const props = args.props;
            const helpers = props.helpers;
            const labels = args.labels;
            const state = helpers.getState();
            const layoutView = state.layoutView;

            const handleLayoutSwitch = (view) => {
              helpers.mergeState({
                layoutView: view,
              });
            };

            return html`
              <div class="results-navbar__layout-switch layout-switch">
                <span class="layout-switch__label btn--text d-none d-md-block">${labels.layoutSwitcher.view}</span>
                <button
                  class="layout-switch__btn ${layoutView === 'alt'
                    ? 'layout-switch__btn--selected'
                    : ''} btn--text btn-none"
                  type="button"
                  onclick=${() => handleLayoutSwitch('alt')}
                  disabled=${layoutView === 'alt'}
                >
                  <span class="d-md-none">${labels.layoutSwitcher.altMobile}</span>
                  <span class="d-none d-md-block">${labels.layoutSwitcher.altDesktop}</span>
                </button>
                <span class="layout-switch__separator"></span>
                <button
                  class="layout-switch__btn ${layoutView === 'default'
                    ? 'layout-switch__btn--selected'
                    : ''} btn--text btn-none"
                  type="button"
                  onclick=${() => handleLayoutSwitch('default')}
                  disabled=${layoutView === 'default'}
                >
                  <span class="d-md-none">${labels.layoutSwitcher.defaultMobile}</span>
                  <span class="d-none d-md-block">${labels.layoutSwitcher.defaultDesktop}</span>
                </button>
              </div>
            `;
          },
        },
        sortOptions: {
          render: function (html, args) {
            const props = args.props;
            const helpers = props.helpers;
            const labels = args.labels;
            const sortOptions = helpers.getSortOptions();
            const state = helpers.getState();
            const showSortModal = state.showSortModal;

            const handleSortToggleClick = (event) => {
              event.preventDefault();
              helpers.mergeState({
                showSortModal: !state.showSortModal,
              });
            };

            const handleSortOptionClick = (id) => {
              helpers.applySortOption(id);
              helpers.mergeState({
                showSortModal: false,
              });
            };

            return html`
              <div class="results-navbar__sort">
                <button
                  onClick=${handleSortToggleClick}
                  class="sort__toggle results-navbar__toggle-btn btn--text btn-none"
                  aria-expanded=${showSortModal}
                >
                  ${labels.sortOptions.sortBy}
                  <svg
                    aria-label="Chevron down icon"
                    class="icon icon-chevron-down"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="m18 9-6 6-6-6"
                      stroke="currentColor"
                      stroke-width="1.5"
                      stroke-linecap="square"
                      vector-effect="non-scaling-stroke"
                    />
                  </svg>
                </button>

                <div class="sort__modal ${showSortModal ? 'sort__modal--active' : ''}" aria-hidden=${!showSortModal}>
                  <ul class="sort__options list-unstyled">
                    ${sortOptions.map(
                      (sortOption, index) => html`
                        <li>
                          <button
                            class="sort__option ${sortOption.selected
                              ? 'sort__option--selected'
                              : ''} btn--text btn-none"
                            type="button"
                            onClick=${() => handleSortOptionClick(sortOption.id)}
                          >
                            ${sortOption.label}
                          </button>
                        </li>
                      `
                    )}
                  </ul>
                </div>
              </div>
            `;
          },
          callbacks: {
            afterEveryRender: function (helpers) {
              const state = helpers.getState();
              const showSortModal = state.showSortModal;
              if (showSortModal) {
                document.body.classList.add(classes.bodySortActive);
                return;
              }
              document.body.classList.remove(classes.bodySortActive);
            },
          },
        },
        products: {
          render: function (html, args) {
            const props = args.props;
            const helpers = props.helpers;
            const products = helpers.getProducts();
            const state = helpers.getState();
            const layoutView = state.layoutView;

            return html`
              <div class="results-grid results-grid--${layoutView}">
                ${products.map((product, index) => html`<${args.templates.product} key=${index} product=${product} />`)}
              </div>
            `;
          },
          callbacks: {
            afterEveryRender: function () {
              document.dispatchEvent(new CustomEvent('results-grid:loaded'));
              // Wishlist Plus (Swym) - custom event dispatched to initialise button for new products loaded
              document.dispatchEvent(new CustomEvent('swym:products-loaded'));
            },
          },
        },
        product: {
          render: function (html, args) {
            const props = args.props;
            const product = props.product;
            const helpers = props.helpers;

            return html`<div
              class="results-grid__tile"
              dangerouslySetInnerHTML=${{__html: renderProductCard(product, helpers)}}
            />`;
          },
        },
        pagination: {
          options: {
            infiniteScroll: settings.paginationType === 'load-more',
            showLoadMoreAfterEvery: settings.paginationType === 'load-more' ? 1 : 0,
          },
          render: function (html, args) {
            const props = args.props;
            const helpers = props.helpers;

            if (props.infiniteScroll) {
              if (helpers.canLoadMoreResults(props.showLoadMoreAfterEvery)) {
                return html`
                  <div class="results-pagination">
                    <${args.templates.loadMore} />
                  </div>
                `;
              }
              return null;
            }
            return html`<${args.templates.paginationLinks} />`;
          },
        },
        loadMore: {
          render: function (html, args) {
            const props = args.props;
            const helpers = props.helpers;
            const labels = args.labels;

            const totalPages = helpers.getTotalPages();
            const currentPage = helpers.getCurrentPage();
            const totalProductsCount = helpers.getTotalProductsCount();
            const displayedProductsCount = currentPage === totalPages ? totalProductsCount : currentPage * itemsPerPage;
            const progressPercentage = (displayedProductsCount * 100) / totalProductsCount;

            const progressText = window.theme?.strings?.collection?.progress
              ?.replace('{{ count }}', displayedProductsCount)
              .replace('{{ total }}', totalProductsCount);

            return html`
              <p>${progressText}</p>
              <div class="results-pagination__progress">
                <div class="results-pagination__progress-bar" style="width: ${progressPercentage}%;"></div>
              </div>
              <button class="results-pagination__btn text--small" onClick=${props.helpers.loadNextPage}>
                ${helpers.isLoading() ? labels.pagination.loading : labels.pagination.loadMore}
              </button>
            `;
          },
        },
        paginationLinks: {
          options: {
            showNumberedPageLinks: true,
            numberedPageLinksWindowSize: 3,
            showPreviousPageLink: true,
            showNextPageLink: true,
            scrollTop: true,
          },
          render: function (html, args) {
            const props = args.props;
            const helpers = props.helpers;
            const pagesToDisplay = helpers.getPagesToDisplay(props.numberedPageLinksWindowSize);
            const hasPreviousPage = helpers.hasPreviousPage();
            const hasNextPage = helpers.hasNextPage();

            return html`
              ${pagesToDisplay.length > 1
                ? html`<nav
                    class="pagination-nav"
                    aria-label=${window.theme?.strings?.a11y?.pagination?.list ?? 'Pagination navigation'}
                  >
                    <div class="results-pagination">
                      <ol class="results-pagination__list">
                        ${props.showPreviousPageLink && hasPreviousPage
                          ? html`
                              <li>
                                <button
                                  class="results-pagination__prev"
                                  onclick=${helpers.goToPreviousPage}
                                  aria-label=${window.theme?.strings?.a11y?.pagination?.prevPage ?? 'Previous page'}
                                >
                                  <span class="results-pagination__arrow" aria-hidden="true"></span>
                                </button>
                              </li>
                            `
                          : null}
                        ${props.showNumberedPageLinks
                          ? pagesToDisplay.map((pageDetail) => {
                              const classes = ['results-pagination__page results-pagination__page-link btn-none'];
                              const isEllipsis = pageDetail.jumpAfter;
                              if (pageDetail.current) classes.push('results-pagination__page--active');
                              const className = classes.join(' ');

                              if (isEllipsis) {
                                return html`
                                  <li>
                                    <span>...</span>
                                  </li>
                                `;
                              }

                              return html`
                                <li>
                                  <button
                                    class=${`${className}`}
                                    onclick=${() => {
                                      helpers.goToPage(pageDetail.page);
                                    }}
                                    disabled=${pageDetail.current}
                                    aria-label=${window.theme?.strings?.a11y?.pagination?.page ?? 'Page'}
                                  >
                                    ${pageDetail.page}
                                  </button>
                                </li>
                              `;
                            })
                          : null}
                        ${props.showNextPageLink && hasNextPage
                          ? html`
                              <li>
                                <button
                                  class="results-pagination__next"
                                  onclick=${helpers.goToNextPage}
                                  aria-label=${window.theme?.strings?.a11y?.pagination?.nextPage ?? 'Next page'}
                                >
                                  <span class="results-pagination__arrow" aria-hidden="true"></span>
                                </button>
                              </li>
                            `
                          : null}
                      </ol>
                    </div>
                  </nav>`
                : null}
            `;
          },
        },
        closeIcon: {
          render(html) {
            return html`
              <svg
                aria-label="Cross icon"
                class="icon icon-cross"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke="currentColor"
                  stroke-linecap="round"
                  stroke-width="1.5"
                  vector-effect="non-scaling-stroke"
                  d="M17 7L7 17M7 7l10 10"
                />
              </svg>
            `;
          },
        },
      },
      callbacks: {
        onSuccessfulAPICall: async (response) => {
          const staticTranslations = window.theme?.tagalys?.staticTranslations || {};
          const translatedResponse = await TagalysMarketTranslations.translate(response, staticTranslations);

          const stringKey = translatedResponse.total > 0 ? 'results' : 'noResults';
          document.title = window.theme.strings.search.metaTitle[stringKey]
            .replace('{{ resultsCount }}', translatedResponse.total)
            .replace('{{ searchTerm }}', translatedResponse.query)
            .replaceAll('&quot;', '"');

          return translatedResponse;
        },
      },
    });
  },
});
